export const UPDATE_SCOOPS = 'UPDATE_SCOOPS';

export const SHOW_INFO = 'SHOW_INFO';

export const SET_TO_CONE = 'SET_TO_CONE';

export const SET_TO_CUP = 'SET_TO_CUP';

export const RESET_STATE = 'RESET_STATE';